import React from "react";
import { Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";

/*
 * ThemeToggle — a sun/moon pill wired to the app theme. Adapted to JS + brand
 * colours from a 21st.dev toggle. `overTeal` tunes the track for the teal hero.
 */
export function ThemeToggle({ className, overTeal = false }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  return (
    <div
      className={cn(
        "flex h-8 w-16 cursor-pointer rounded-full p-1 transition-colors duration-300",
        className
      )}
      onClick={toggle}
      role="button"
      tabIndex={0}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      }}
      style={{
        background: isDark
          ? "rgba(10,38,37,0.55)"
          : overTeal
          ? "rgba(247,246,242,0.18)"
          : "rgba(13,95,94,0.08)",
        border: `1px solid ${overTeal ? "rgba(247,246,242,0.3)" : "var(--nexxis-border-strong)"}`,
      }}
    >
      <div className="flex w-full items-center justify-between">
        <div
          className={cn(
            "flex h-6 w-6 items-center justify-center rounded-full transition-transform duration-300",
            isDark ? "translate-x-0" : "translate-x-8"
          )}
          style={{ background: isDark ? "#0D5F5E" : "#BEE5E0" }}
        >
          {isDark ? (
            <Moon className="h-4 w-4" strokeWidth={1.6} style={{ color: "#BEE5E0" }} />
          ) : (
            <Sun className="h-4 w-4" strokeWidth={1.6} style={{ color: "#0D5F5E" }} />
          )}
        </div>
        <div
          className={cn(
            "flex h-6 w-6 items-center justify-center rounded-full transition-transform duration-300",
            isDark ? "" : "-translate-x-8"
          )}
        >
          {isDark ? (
            <Sun
              className="h-4 w-4"
              strokeWidth={1.6}
              style={{ color: overTeal ? "rgba(247,246,242,0.55)" : "var(--nexxis-ink-muted)" }}
            />
          ) : (
            <Moon
              className="h-4 w-4"
              strokeWidth={1.6}
              style={{ color: overTeal ? "rgba(247,246,242,0.55)" : "var(--nexxis-ink-muted)" }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
